import React from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"
import errorImg from "../../assets/images/404.png"

const Pages404 = ({ auth }) => {
    document.title = "404 Page Not Found"

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row className="justify-content-center">
                        <Col lg={6} md={8}>
                            <div className="text-center mb-5 pt-5">
                                <h1 className="display-1 fw-semibold">
                                    4<i className="bx bx-buoy bx-spin text-primary display-3"></i>4
                                </h1>
                                <h4 className="text-uppercase">Sorry, page not found</h4>
                                <p className="text-muted mb-4">
                                    The page you are looking for might have been removed, had its name changed,
                                    or is temporarily unavailable.
                                </p>
                            </div>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col md={8} xl={6}>
                            <div>
                                <img src={errorImg} alt="" className="img-fluid d-block mx-auto" style={{ height: '20rem' }} />
                            </div>
                        </Col>
                        <div className="mt-5 text-center">
                            <Link
                                className="btn btn-primary waves-effect waves-light"
                                to={auth ? "/admin/dashboard" : "/"}
                            >
                                <i className="bx bx-arrow-back me-1"></i> {auth ? "Back to Dashboard" : "Back to Login"}
                            </Link>
                        </div>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )
}

export default Pages404 